import type { Listing } from '@/services/api';
import { evaluateDealType } from '@/utils/dealEvaluation';
import { useMemo } from 'react';

export const useDealType = (listing: Listing) => {
    return useMemo(() => {
        if (listing.market_status?.price_ratio) {
            return evaluateDealType(listing.market_status.price_ratio);
        }
        return 'none';
    }, [listing.market_status?.price_ratio]);
}; 